import React from "react";
import AddToCartToSeePrice from "./AddToCartToSeePrice";
import { VariantProps } from ".";

const N = ({
  mapPrice,
  user,
  selectedProduct,
  productListingView,
}: VariantProps) => {
  const props = {
    unitOfMeasure: selectedProduct.unitOfMeasure,
    price: selectedProduct.price,
    user,
    mapPrice,
    type: selectedProduct.price.minimumAdvertisedPriceProperties.type,
    showLoginLink:
      selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers,
    priceCrossedOut: true,
    showEnticement: true,
    productListingView,
  };
  return <AddToCartToSeePrice {...props} />;
};

export default N;
